import React from 'react';
import { AuthParamKeys } from '~/models/Auth/AuthParamModel';
import { ProviderType } from '../../constants';
import LastLoginButton from './LastLoginButton';
import { ButtonComponents } from './ProviderButtons';

interface Props {
  signup?: boolean;
  authParams: { [key in AuthParamKeys]: string };
  lastLoginProvider?: ProviderType;
}

const AuthButtons = ({ signup, authParams, lastLoginProvider }: Props) => {
  const otherButtonKeys = Object.keys(ButtonComponents).filter(
    (key) => key !== lastLoginProvider,
  );
  return (
    <>
      {lastLoginProvider && (
        <LastLoginButton
          signup={signup}
          authParams={authParams}
          lastLoginProvider={lastLoginProvider}
        />
      )}
      {otherButtonKeys.map((otherButtonKey) => {
        const ButtonComponent = ButtonComponents[otherButtonKey];
        return (
          <ButtonComponent
            key={otherButtonKey}
            signup={signup}
            authParams={authParams}
          />
        );
      })}
    </>
  );
};

export default AuthButtons;
